import { render, staticRenderFns } from "./D3PieChart.vue?vue&type=template&id=b2098b5a&scoped=true&"
import script from "./D3PieChart.vue?vue&type=script&lang=js&"
export * from "./D3PieChart.vue?vue&type=script&lang=js&"
import style0 from "./D3PieChart.vue?vue&type=style&index=0&id=b2098b5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2098b5a",
  null
  
)

export default component.exports